import React, { useState,useEffect } from 'react';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import './TestimonialCarousel.scss';
import testimonial_back from '../../images/testimonial-back.png';

const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      content: "Highly recommend MantraFlex! After my rotator cuff surgery, Priya visited me at home and provided exceptional care. Her expertise and personalized approach made my recovery process so much easier. She was incredibly patient and always took the time to explain the exercises and their benefits. I can't thank her enough!",
      name: "Martina Colin",
    },
    {
      id: 2,
      content: "I was hesitant about physiotherapy at first, but she completely changed my mind. Priya worked with me after my hip replacement, and her dedication and encouragement motivated me to push through the tough days. Thanks to her, I'm walking comfortably again.",
      name: "Harshil Vaghani",
    },
    {
      id: 3,
      content: "MantraFlex was a lifesaver after my back injury. Priya's in-home sessions were exactly what I needed to get back on track. Her warm personality and tailored exercises helped me regain mobility without ever feeling overwhelmed. I don't know what I would have done without her.",
      name: "Sam Wilson",
    },
    {
      id: 4,
      content: "Working with MantraFlex was the best decision I made after my knee surgery. Priya's professionalism and attention to detail ensured I was progressing safely and effectively. I appreciated how she adjusted my plan based on how I was feeling each day. Truly top-notch service!",
      name: "Emily Davis",
    },
    {
      id: 5,
      content: "I can't say enough good things about MantraFlex. After my wrist fracture, I struggled with even the simplest tasks. Priya not only helped me regain strength but also brought a positive energy that made every session enjoyable. It's rare to find someone who combines skill and compassion so perfectly.",
      name: "Sam Wilson",
    },
    {
      id: 6,
      content: "Highly recommend MantraFlex! After my rotator cuff surgery, Priya visited me at home and provided exceptional care. Her expertise and personalized approach made my recovery process so much easier. She was incredibly patient and always took the time to explain the exercises and their benefits. I can't thank her enough!",
      name: "Emily Davis",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }, 3000);
  
    return () => clearInterval(interval);
  }, []);
  
  useEffect(() => {
    if (currentIndex >= testimonials.length) {
      setCurrentIndex(0);
    }
  }, [currentIndex, testimonials.length]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="testimonial-carousel">
      <div className="testimonial-container" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className="testimonial">
            <div className="testimonial-content">
              <p className="testimonial-text">&ldquo;{testimonial.content}&rdquo;</p>
              <h3 className="testimonial-name">{testimonial.name}</h3>
            </div>
          </div>
        ))}
      </div>
      <button 
        className="nav-button prev"
        onClick={handlePrev}
        aria-label="Previous testimonial"
      >
        &lt;
      </button>
      <button 
        className="nav-button next"
        onClick={handleNext}
        aria-label="Next testimonial"
      >
        &gt;
      </button>
    </div>
  );
};

export default TestimonialCarousel;
